import * as React from 'react'
import type * as Polymorphic from '../../../../react-utils/polymorphic'
import cn from 'classnames'
import styles from './modal-footer.module.css'

export interface ModalFooterProps extends React.HTMLAttributes<HTMLElement> {}

/**
 * ModalFooter houses the action buttons of the modal.
 */
export const ModalFooter = React.forwardRef((props, ref) => {
  const { className, ...rest } = props
  const _className = cn(styles.paypal_modal__footer, className)

  const footerStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  }

  return (
    <footer
      ref={ref as any}
      {...rest}
      style={{ ...footerStyles }}
      className={_className}
    />
  )
}) as Polymorphic.ForwardRefComponent<'footer', ModalFooterProps>

ModalFooter.displayName = 'ModalFooter'
